import React, { useContext } from 'react';
import { AppPageProps, AppState, LocalizationContext } from '../app';
import { Col, Container, Row } from '@pds-react/grid';
import Button from '@pds-react/button';

const BuiltNotActivated: React.FunctionComponent<AppPageProps> = (props: AppPageProps) => {
  const localization = useContext(LocalizationContext);

  let title = 'Account Not Activated';
  let description = "We've previously sent an email to the email address on file with instructions to continue setting up an account.";
  let support = 'If you need further help, please contact the Advisor Web Support Team.';
  let supportNumber = '866-237-9742';
  let goBack = 'Go back';

  if (localization?.isInitialized) {
    description = localization.t('built-not-activated:description');
    title = localization.t('built-not-activated:title');
    support = localization.t('built-not-activated:support');
    supportNumber = localization.t('built-not-activated:support-number');
    goBack = localization.t('misc:go-back-button');
  }

  return (
    <>
      <Container style={{ marginTop: '40px', marginBottom: '40px' }}>
        <Row>
          <Col span={12} sm={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} xl={{ span: 4, offset: 4 }}>
            <div className="pds-typography-center">
              <h1 className="pds-typography-h2">{title}</h1>
            </div>
            <br />
            <div className="pds-typography-center">
              <p>{description}</p>
            </div>
            <div className="pds-typography-center">
              <p>{support}</p>
            </div>
            <div className="pds-typography-center">
              <p>{supportNumber}</p>
            </div>
            <div className="pds-typography-center">
              <Button
                onClick={() => {
                  props.changeState(AppState.COLLECT_CRD);
                }}
              >
                {goBack}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BuiltNotActivated;
